import { joinUrlOrPath, getLocale, stringifyStoreId } from '../utils';
import { Locale } from './locale';
import { LOCALIZED } from './localized';

const locale = getLocale();

export const LEGACY_URL = {
    [Locale['en-US']]: process.env.NEXT_PUBLIC_LEGACYAPP_BASE_URL_US ?? '/',
    [Locale['en-CA']]: process.env.NEXT_PUBLIC_LEGACYAPP_BASE_URL_CA ?? '/',
};

const { localeShorthand, localeSFCC } = LOCALIZED;
const baseLegacyUrl = LEGACY_URL[locale] ?? '/';
const legacyBaseAccountPath = joinUrlOrPath(baseLegacyUrl, '/account/');
const velocityBaseAccountPath = '/account';

const legacyBaseDwStorePath = joinUrlOrPath(baseLegacyUrl, `/on/demandware.store/Sites-${localeSFCC}-Site/default/`);

export const NAVIGATION_URLS = {
    legacy: {
        account: {
            aboutYou: joinUrlOrPath(legacyBaseAccountPath, '/about-you/'),
            autoShip: joinUrlOrPath(baseLegacyUrl, '/auto-ship/'),
            base: legacyBaseAccountPath,
            creditCards: joinUrlOrPath(legacyBaseAccountPath, '/credit-cards/'),
            favorites: joinUrlOrPath(legacyBaseAccountPath, '/favorites/'),
            orderHistory: joinUrlOrPath(legacyBaseAccountPath, '/order-history/'),
            servicesGrooming: joinUrlOrPath(legacyBaseAccountPath, '/services-grooming/'),
            treatOffers: joinUrlOrPath(legacyBaseAccountPath, '/treats-offers/'),
        },
        autoship: joinUrlOrPath(baseLegacyUrl, '/auto-ship/'),
        base: baseLegacyUrl,
        cart: joinUrlOrPath(baseLegacyUrl, '/cart/'),
        createAccount: joinUrlOrPath(legacyBaseDwStorePath, '/AccountController-CreateAccount'),
        logout: joinUrlOrPath(legacyBaseDwStorePath, '/Login-Logout/'),
        petAdoption: joinUrlOrPath(baseLegacyUrl, '/pet-adoption'),
        stores: joinUrlOrPath(baseLegacyUrl, `/stores/${localeShorthand}`),
        storeLocator: {
            base: joinUrlOrPath(baseLegacyUrl, '/store-locator/'),
            store: (storeId: number) =>
                joinUrlOrPath(baseLegacyUrl, `/store-locator/store/?storeID=${stringifyStoreId(storeId) || ''}`),
        },
        shopByBrand: joinUrlOrPath(baseLegacyUrl, '/shop-by-brand/'),
    },
    velocity: {
        plp: {
            featuredBrands: '/featured-brands',
            search: '/search',
        },
        cart: '/cart',
        checkout: '/checkout',
        checkoutLogin: '/checkout-login',
        orderConfirmation: '/order-confirmation',
        cartNotFound: '/cart-not-found',
        createAccount: '/create-account',
        signIn: '/sign-in',
        account: {
            base: `${velocityBaseAccountPath}/`,
            treatOffers: '/treats-rewards/authenticated',
            offers: '/treats-rewards/authenticated/offers',
            aboutYou: `${velocityBaseAccountPath}/about-you`,
            creditCards: `${velocityBaseAccountPath}/credit-cards`,
            autoShip: `${velocityBaseAccountPath}/auto-ship`,
            orderHistory: `${velocityBaseAccountPath}/order-history`,
            orderSearch: `${velocityBaseAccountPath}/order-search`,
            orderDetails: `${velocityBaseAccountPath}/order-details`,
            servicesGrooming: `${velocityBaseAccountPath}/services-grooming`,
        },
    },
};
